import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'
import { Separator } from 'widgets/Separator'

type AddStepButtonProps = {
  onPress: () => void
  hideSeparator?: boolean
}

export const AddStepButton = ({ onPress, hideSeparator = false }: AddStepButtonProps) => {
  return (
    <Box margin='md'>
      {!hideSeparator && <Separator />}
      <Box position='absolute' width='100%' height='100%' align='center' justifyContent='center'>
        <Pressable onPress={onPress} style={{ width: 28, height: 28 }}>
          <Box
            width={28}
            height={28}
            backgroundColor='v2primary'
            borderRadius='lg'
            align='center'
            justifyContent='center'
          >
            <Icon name='plus' size={22} color='white' />
          </Box>
        </Pressable>
      </Box>
    </Box>
  )
}
